<form [formGroup]="form">
  <div class="my-3 my-md-5 border rounded-3 shadow bg-light">
    <div class="row p-3 g-4">
      <div class="col-12">
        <label class="mb-1 form-label">Вид обява*</label>
        <div class="form-check">
          <input
            id="fixed-price"
            type="radio"
            class="form-check-input"
            formControlName="adType"
            [value]="AdType.DirectSale">
          <label for="fixed-price" class="form-check-label">Обява с фиксирана цена</label>
          <button
            type="button"
            (click)="showFixedPriceAdTypeInfo()"
            class="btn btn-link text-dark p-0">
            <i class="px-1 text-primary-emphasis fa-regular fa-circle-question" aria-hidden="true"></i>
          </button>
        </div>
        <div class="form-check">
          <input
            id="auction"
            type="radio"
            class="form-check-input"
            formControlName="adType"
            [value]="AdType.Auction">
          <label for="auction" class="form-check-label">Обява с наддаване (аукцион)</label>
          <button
            type="button"
            (click)="showAuctionAdTypeInfo()"
            class="btn btn-link text-dark p-0">
            <i class="px-1 text-primary-emphasis fa-regular fa-circle-question" aria-hidden="true"></i>
          </button>
        </div>
      </div>
      @if (adType?.value === AdType.DirectSale) {
        <div class="col-12 col-md-6 mb-4">
          <label for="fixedPrice" class="mb-0 form-label">Фиксирана цена*</label>
          <div class="input-group">
            <input
              min="0"
              type="number"
              id="fixedPrice"
              pattern="^\d*(\.\d{0,2})?$"
              formControlName="fixedPrice"
              class="form-control rounded-start-1"
              placeholder="Въведете фиксирана цена..."
              [class.is-valid]="fixedPrice?.touched && fixedPrice?.valid"
              [class.is-invalid]="fixedPrice?.touched && fixedPrice?.invalid">
            <span class="input-group-text rounded-end-1">лв.</span>
            <p class="invalid-feedback m-0">Задължително поле!</p>
          </div>
          <small class="text-muted">
            Въведете фиксирана цена в български лева.
          </small>
        </div>
        <div class="col-12 mt-0">
          <div class="mb-2 form-check">
            <input
              type="checkbox"
              id="isOfferSubmissionAllowed"
              class="form-check-input"
              formControlName="isOfferSubmissionAllowed">
            <label for="isOfferSubmissionAllowed" class="form-check-label">
              Приемам ценови предложения
            </label>
            <button
              type="button"
              (click)="showAllowOfferInfo()"
              class="btn btn-link text-dark p-0"
              aria-label="Информация за ценови предложения">
              <i class="px-1 text-primary-emphasis fa-regular fa-circle-question" aria-hidden="true"></i>
            </button>
          </div>
        </div>
      } @else {
        <div class="col-12 col-md-6">
          <label for="startingPrice" class="mb-0 form-label">Начална цена*</label>
          <div class="input-group">
            <input
              min="0"
              type="number"
              id="startingPrice"
              pattern="^\d*(\.\d{0,2})?$"
              formControlName="startingPrice"
              placeholder="Въведете начална цена..."
              class="form-control rounded-start-1"
              [class.is-valid]="startingPrice?.touched && startingPrice?.valid"
              [class.is-invalid]="startingPrice?.touched && startingPrice?.invalid">
            <span class="input-group-text rounded-end-1">лв.</span>
            <p class="invalid-feedback m-0">Задължително поле!</p>
          </div>
          <small class="text-muted">
            Въведете начална цена в български лева.
          </small>
        </div>
        <div class="col-12 col-md-6">
          <label for="bidIncrement" class="mb-0 form-label">Минимална стъпка*</label>
          <div class="input-group">
            <input
              min="0"
              type="number"
              id="bidIncrement"
              pattern="^\d*(\.\d{0,2})?$"
              formControlName="bidIncrement"
              placeholder="Въведете минимална стъпка..."
              class="form-control rounded-start-1"
              [class.is-valid]="bidIncrement?.touched && bidIncrement?.valid"
              [class.is-invalid]="bidIncrement?.touched && bidIncrement?.invalid">
            <span class="input-group-text rounded-end-1">лв.</span>
            <p class="invalid-feedback m-0">Задължително поле!</p>
          </div>
          <small class="text-muted">
            Въведете минимална стъпка в български лева.
          </small>
        </div>
        <div class="col-12">
          <div class="mb-2 form-check">
            <input
              type="checkbox"
              id="hasBuyNowPrice"
              class="form-check-input"
              formControlName="hasBuyNowPrice">
            <label for="hasBuyNowPrice" class="form-check-label">
              Купи сега цена
            </label>
            <button
              type="button"
              (click)="showBuyNowPriceInfo()"
              class="btn btn-link text-dark p-0">
              <i class="px-1 text-primary-emphasis fa-regular fa-circle-question" aria-hidden="true"></i>
            </button>
          </div>
        </div>
        @if (hasBuyNowPrice?.value) {
          <div class="col-12 col-md-6 mt-0 mb-4">
            <div class="input-group">
              <input
                min="0"
                type="number"
                id="buyNowPrice"
                pattern="^\d*(\.\d{0,2})?$"
                formControlName="buyNowPrice"
                placeholder="Въведете купи сега цена..."
                class="form-control rounded-start-1"
                [class.is-valid]="buyNowPrice?.touched && buyNowPrice?.valid"
                [class.is-invalid]="buyNowPrice?.touched && buyNowPrice?.invalid">
              <span class="input-group-text rounded-end-1">лв.</span>
              <p class="invalid-feedback m-0">Задължително поле!</p>
            </div>
            <small class="text-muted">Въведете купи сега цена в български лева.</small>
          </div>
        }
        <div class="col-12 mt-0">
          <div class="mb-2 form-check">
            <input
              type="checkbox"
              id="hasReservedPrice"
              class="form-check-input"
              formControlName="hasReservedPrice">
            <label for="hasReservedPrice" class="form-check-label">
              Запазена цена
            </label>
            <button
              type="button"
              (click)="showReservedPriceInfo()"
              class="btn btn-link text-dark p-0">
              <i class="px-1 text-primary-emphasis fa-regular fa-circle-question" aria-hidden="true"></i>
            </button>
          </div>
        </div>
        @if (hasReservedPrice?.value) {
          <div class="col-12 col-md-6 mt-0 mb-4">
            <div class="input-group">
              <input
                min="0"
                type="number"
                id="reservedPrice"
                pattern="^\d*(\.\d{0,2})?$"
                formControlName="reservedPrice"
                placeholder="Въведете запазена цена..."
                class="form-control rounded-start-1"
                [class.is-valid]="reservedPrice?.touched && reservedPrice?.valid"
                [class.is-invalid]="reservedPrice?.touched && reservedPrice?.invalid">
              <span class="input-group-text rounded-end-1">лв.</span>
              <p class="invalid-feedback m-0">Задължително поле!</p>
            </div>
            <small class="text-muted">Въведете запазена цена в български лева.</small>
          </div>
        }
        <div class="col-12 mt-0">
          <div class="mb-2 form-check">
            <input
              type="checkbox"
              id="hasAdBidExtensionTimeOptionId"
              class="form-check-input"
              formControlName="hasAdBidExtensionTimeOptionId">
            <label for="hasAdBidExtensionTimeOptionId" class="form-check-label">
              Удължаване на аукциона
            </label>
            <button
              type="button"
              (click)="showBidExtensionTimeInfo()"
              class="btn btn-link text-dark p-0">
              <i class="px-1 text-primary-emphasis fa-regular fa-circle-question" aria-hidden="true"></i>
            </button>
          </div>
        </div>
        @if (hasAdBidExtensionTimeOptionId?.value) {
          <div class="col-12 col-md-6 mt-0">
            <ng-select
              [clearable]="false"
              [searchable]="false"
              [items]="adBidExtensionTimeOptions"
              bindValue="adBidExtensionTimeOptionId"
              bindLabel="adBidExtensionTimeOptionName"
              formControlName="adBidExtensionTimeOptionId"
              notFoundText="Няма намерени стойности"
              placeholder="Изберете време"
              [class.is-valid]="adBidExtensionTimeOptionId?.touched && adBidExtensionTimeOptionId?.valid"
              [class.is-invalid]="adBidExtensionTimeOptionId?.touched && adBidExtensionTimeOptionId?.invalid">
            </ng-select>
            @if (adBidExtensionTimeOptionId?.touched && adBidExtensionTimeOptionId?.invalid) {
              <p class="m-0 invalid-feedback">Задължително поле!</p>
            }
            <small class="text-muted">
              Изберете с колко да се увлеличава времето до края на аукцион.
            </small>
          </div>
        }
      }
    </div>
  </div>
  <div class="my-3 my-md-5 border rounded-3 shadow bg-light">
    <div class="row p-3 g-4">
      <div class="col-12">
        <div class="mb-2 form-check">
          <input
            type="checkbox"
            id="hasAdAutoRenewAfterExpiredId"
            class="form-check-input"
            formControlName="hasAdAutoRenewAfterExpiredId">
          <label for="hasAdAutoRenewAfterExpiredId" class="form-check-label">
            Автоматично обновяване след завършване без продажба
            <button
              type="button"
              (click)="showAutoRenewAfterExpiredInfo()"
              class="btn btn-link text-dark p-0">
              <i class="px-1 text-primary-emphasis fa-regular fa-circle-question" aria-hidden="true"></i>
            </button>
          </label>
        </div>
        @if (hasAdAutoRenewAfterExpiredId?.value) {
          <div class="col-12 col-md-6 mt-0 mb-4">
            <ng-select
              [clearable]="false"
              [searchable]="false"
              [items]="adAutoRenewOptions"
              bindValue="adAutoRenewOptionId"
              bindLabel="adAutoRenewOptionName"
              formControlName="adAutoRenewAfterExpiredId"
              notFoundText="Няма намерени стойности"
              placeholder="Изберете стойност"
              [class.is-valid]="adAutoRenewAfterExpiredId?.touched && adAutoRenewAfterExpiredId?.valid"
              [class.is-invalid]="adAutoRenewAfterExpiredId?.touched && adAutoRenewAfterExpiredId?.invalid">
            </ng-select>
            @if (adAutoRenewAfterExpiredId?.touched && adAutoRenewAfterExpiredId?.invalid) {
              <p class="m-0 invalid-feedback">Задължително поле!</p>
            }
            <small class="text-muted">
              Изберете колко пъти обявата да се обновява след завършване без продажба
            </small>
          </div>
        }
      </div>
      <div class="col-12 col-md-6">
        <label for="startDate" class="mb-0 form-label">Начална дата и час*</label>
        <div class="input-group">
          <input
            ngbDatepicker
            id="startDate"
            name="startDate"
            formControlName="startDate"
            #startDatepicker="ngbDatepicker"
            placeholder="Изберете начална дата (дд.мм.гггг)"
            [minDate]="startDateMinDate"
            [maxDate]="startDateMaxDate"
            class="form-control rounded-start-1"
            [class.border-success]="startDate?.touched && startDate?.valid"
            [class.border-danger]="startDate?.touched && startDate?.invalid"/>
          <button
            type="button"
            [disabled]="startDatepicker.disabled"
            class="btn btn-outline-secondary"
            (click)="startDatepicker.toggle()">
            <i class="fa-regular fa-calendar-days"></i>
          </button>
        </div>
        @if (startDate?.touched && startDate?.invalid) {
          <small class="text-danger">Задължително поле във формат дд.мм.гггг!</small>
        }
        <div>
          <small class="text-muted">
            Изберете датата и часа, от която искате обявата да стане активна.
          </small>
        </div>
      </div>
      <div class="col-6 col-md-3">
        <span class="form-label">Час*</span>
        <ng-select
          [clearable]="false"
          [searchable]="false"
          [items]="hourOptions"
          bindValue="value"
          bindLabel="label"
          formControlName="startHour"
          notFoundText="Няма намерени часове"
          placeholder="Изберете час"
          [class.is-valid]="startHour?.touched && startHour?.valid"
          [class.is-invalid]="startHour?.touched && startHour?.invalid">
        </ng-select>
        @if (startHour?.touched && startHour?.invalid) {
          <p class="m-0 invalid-feedback">Задължително поле!</p>
        }
        <small class="text-muted">
          Изберете час в диапазона от 00 до 23.
        </small>
      </div>
      <div class="col-6 col-md-3">
        <span class="form-label">Минути*</span>
        <ng-select
          [clearable]="false"
          [searchable]="false"
          [items]="minutesOptions"
          bindValue="value"
          bindLabel="label"
          formControlName="startMinutes"
          notFoundText="Няма намерени минути"
          placeholder="Изберете минути"
          [class.is-valid]="startMinutes?.touched && startMinutes?.valid"
          [class.is-invalid]="startMinutes?.touched && startMinutes?.invalid"
        >
        </ng-select>
        @if (startMinutes?.touched && startMinutes?.invalid) {
          <p class="m-0 invalid-feedback">Задължително поле!</p>
        }
        <small class="text-muted">
          Изберете минути в диапазона от 00 до 59.
        </small>
      </div>
      <div class="col-12 col-md-6">
        <label for="endDate" class="mb-0 form-label">Крайна дата и час*</label>
        <div class="input-group">
          <input
            ngbDatepicker
            id="endDate"
            name="endDate"
            formControlName="endDate"
            #endDatepicker="ngbDatepicker"
            placeholder="Изберете крайна дата (дд.мм.гггг)"
            [minDate]="endDateMinDate"
            [maxDate]="endDateMaxDate"
            class="form-control rounded-start-1"
            [class.border-success]="endDate?.touched && endDate?.valid"
            [class.border-danger]="endDate?.touched && endDate?.invalid"/>
          <button
            type="button"
            [disabled]="endDatepicker.disabled"
            class="btn btn-outline-secondary"
            (click)="endDatepicker.toggle()">
            <i class="fa-regular fa-calendar-days"></i>
          </button>
        </div>
        @if (endDate?.touched && endDate?.invalid) {
          <small class="text-danger">Задължително поле във формат дд.мм.гггг!</small>
        }
        <div>
          <small class="text-muted">
            Изберете датата и часа, до която искате обявата да е активна.
          </small>
        </div>
      </div>
      <div class="col-6 col-md-3">
        <span class="form-label">Час*</span>
        <ng-select
          [clearable]="false"
          [searchable]="false"
          [items]="hourOptions"
          bindValue="value"
          bindLabel="label"
          formControlName="endHour"
          notFoundText="Няма намерени часове"
          placeholder="Изберете час"
          [class.is-valid]="endHour?.touched && endHour?.valid"
          [class.is-invalid]="endHour?.touched && endHour?.invalid">
        </ng-select>
        @if (endHour?.touched && endHour?.invalid) {
          <p class="m-0 invalid-feedback">Задължително поле!</p>
        }
        <small class="text-muted">
          Изберете час в диапазона от 00 до 23.
        </small>
      </div>
      <div class="col-6 col-md-3">
        <span class="form-label">Минути*</span>
        <ng-select
          [clearable]="false"
          [searchable]="false"
          [items]="minutesOptions"
          bindValue="value"
          bindLabel="label"
          formControlName="endMinutes"
          notFoundText="Няма намерени минути"
          placeholder="Изберете минути"
          [class.is-valid]="endMinutes?.touched && endMinutes?.valid"
          [class.is-invalid]="endMinutes?.touched && endMinutes?.invalid">
        </ng-select>
        @if (endMinutes?.touched && endMinutes?.invalid) {
          <p class="m-0 invalid-feedback">Задължително поле!</p>
        }
        <small class="text-muted">
          Изберете минути в диапазона от 00 до 59.
        </small>
      </div>
    </div>
  </div>
</form>
